const commonEn = {
    "max_8_tags": "You can select up to 8 tags.",
    "max_8_tags_hint": "Maximum 8 tags can be selected.",
    "refund_success": "Refund successful!",
    "refund_failed": "Refund failed!",
    "extra_column": "Extra empty column at the end",
    "print": "Print",
    "save_as_pdf": "Save as PDF",
    "id": "Identifier",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleted": "Deleted",
    "view": "View",
    "actions": "Actions",
    "details": "Details",
    "refund": "Refund",
    "close": "Close",
    "more_info": "More information",
    "next": "Next",
    "previous": "Previous",
    "show_x_out_of_x": "Show {{count}} out of {{maxCount}}",
    "guest": "Guest",
    "guests": "Guests",
    "refund_question": " Are you sure you want to refund? This action cannot be undone.",
    "search": "Search",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "reservations": "Reservations",
    "note": "Note",
    "notes": "Notes",
    "save": "Save",
    "download": "Download",
    "download_csv": "Download (CSV)",
    "marketing_consent": "Marketing consent",
    "domestic": "Domestic",
    "foreign": "Foreign",
    "seat": "main",
    "day": "Day",
    "add": "Add",
    "add_new": "Add new",
    "edit": "Edit",
    "no_data": "No data",
    "language": "Language",
    "languages": {
        "en": "English",
        "hu": "Hungarian",
        "ru": "Russian",
        "de": "German",
        "fr": "France",
        "es": "Spanish",
        "it": "Italian",
        "sk": "Slovak",
        "uk": "Ukrainian",
        "hr": "Croatian",
        "he": "Hebrew"
    },
    "no_selected": "Not selected",
    "selected": "selected",
    "lunch": "Lunch",
    "dinner": "Dinner",
    "afternoon": "Afternoon",
    "table": "Table",
    "tables": "Tables",
    "internal_note": "Internal Note",
    "date": "Date",
    "select_daterange": "Select date(s)",
    "time_date": "Date",
    "duration": "Duration",
    "reservation": "Reservation",
    "all": "All",
    "note_detailed": "Detailed Note Description",
    "valid_from": "Validity from",
    "valid_from_time": "Validity from (time)",
    "valid_to": "Validity to",
    "valid_to_time": "Validity to (time)",
    "copy": "Copy",
    "copied_to_clipboard": "Copied to clipboard",
    "select_file": "Select File",
    "link": "Link",
    "query": "Query",
    "payments": "Payments",
    "status": "Status",
    "commission": "Commission",
    "amount_paid": "Amount Paid",
    "sms_fee_amount_net": "SMS Fee (net)",
    "file_name": "File Name",
    "date_interval": "Date Interval",
    "previous_month": "Previous month",
    "month": "Month",
    "comparison_mode": "Mode",
    "full_month": "Full month",
    "to_date": "To date",
    "full_month_warning": "This month is not over yet, so a full-month comparison can be misleading. Choose \"To date\" to compare the same period in each month.",
    "phone_number": "Phone Number",
    "titles": {
        "group_reservation_details": "Group offer details",
        "main_title": "ReservOurs Admin",
        "reservations": "Table View",
        "events": "Events",
        "payments": "Payments",
        "guests": "Guests",
        "settings": "Settings",
        "knowledge_base": "Knowledge Base",
        "reservation_time_table": "Time Slot View",
        "table_planner": "Table Planner",
        "giftcards": "Gift Cards",
        "group_reservation": "Group Offers",
        "waitlist": "Waitlist",
        "group_reservation_edit": "Edit Group Reservation",
        "statistics": "Statistics",
        "not_found": "Page Not Found",
        "logout": "Logout",
        "login": "Login",
        "password_reset": "Password Reset",
        "registration": "Registration",
        "floor_plan_designer": "Floor Plan Designer",
    },
    "page_not_found": "Page not found",
    "not_found_description": "Please check the URL or go back to the homepage.",
    "back_to_home": "Back to homepage",
    "richtext_placeholder": "Type your text here...",
    "person_amount": "people",
    "no_results": "No results",
    "no_data_to_display": "No data to display",
    "labels": "Labels",
    "save_guest_info": "Save guest information",
    "cancelled_reservations": "Cancelled Reservations",
    "guest_info_updated": "Guest information updated",
    "currency": "Currency",
    "select": "Select",
    "not_set": "Not set",
    "yes": "Yes",
    "no": "No",
    "saved_successfully": "Saved successfully",
    "deleted_successfully": "Deleted successfully",
    "select_to_edit": "Select a row to edit",
    "type": "Type",
    "no_more_available_labels": "No more available labels",
    "closed": "Closed",
    "logout": "Logout",
    "hour": "Hour",
    "invalid_value": "Invalid value",
    "invalid_date_range": "Invalid date range",
    "field_required": "This field is required",
    "file_too_large": "File is too large (max 2MB)",
    "file_is_not_image_type": "File is not an image type",
    "for_minutes": "for minutes",
    "send_mail": "Send email",
    "email_template": "Email template",
    "send": "Send",
    "email_text": "Email text",
    "email_sent": "Email sent",
    "approve": "Approve",
    "decline": "Decline",
    "reset_form": "Reset form",
    "back_to_list": "Back to list",
    "send_sms": "Send SMS",
    "sms_sent": "SMS sent",
    "no_reservations_to_show": "No reservations to show",
    "time": "Time",
    "statistics": "Statistics",
    "reviews": "Reviews",
    "length": "Length",
    "occasion": "Occasion",
    "datatable_info": "Showing _START_ to _END_ of _TOTAL_ entries",
    "monthly_reservations": "Monthly reservation data",
    "message_template": "Message template",
    "required_field": "Required field",
    "value_not_valid": "Value not valid",
    "warning": "Warning",
    "view_invoices": "View invoices",
    "new_table": "New table",
    "selected_table": "Edit selected table",
    "no_table_selected_tooltip": "No table selected.",
    "table_name": "Table name",
    "table_size": "Table size",
    "table_shape": "Table shape",
    "table_type": "Table type",
    "table_types": {
        "inside": "Indoor",
        "outside": "Outdoor",
        "blocked": "Blocked"
    },
    "reservation_type_labels": {
        "inside": "Inside",
        "outside": "Outside",
        "blocked": "Blocked / Not bookable online"
    },
    "table_shapes": {
        "rectangle": "Rectangle",
        "circle": "Circle"
    },
    "changes_saved": "Changes saved",
    "save_changes": "Save changes",
    "min_table_size": "Minimum table size",
    "remove": "Remove",
    "remove_table": "Remove table",
    "remove_table_confirmation": "Are you sure you want to remove this table? Once the changes are saved, the deletion cannot be undone.",
    "table_angle_label": "Table rotation (°)",
    "sizes_by_table_types": "Seats by table types",
    "selected_table_by_table_types": "Seats in selected room",
    "sizes_by_rooms": "Seats by rooms",
    "table_count": "Number of tables",
    "table_size_space": "Seats",
    "room": "Room",
    "announcements": "Announcements",
    "voucher_uid": "Gift card ID",
    "voucher_value": "Gift card value",
    "voucher_used": "Used",
    "toggle_voucher_confirmation": "Are you sure you want to mark gift card {{voucherUid}} as {{state}}?",
    "used": "Used",
    "unused": "Unused",
    "mark_unused": "Mark as unused",
    "mark_used": "Mark as used",
    "not_used": "Not used",
    "buyer_name": "Buyer name",
    "selling_date": "Selling date",
    "giftcard_search_ignores_date_interval": "The search covers all gift cards, regardless of the date interval.",
    "giftcards_title": "Gift Cards",
    "no_restaurant": "No such restaurant",
    "paid": "paid",
    "coupon_code": "Coupon code",
    "payment_in_progress": "payment in progress",
    "copy_display_order": "Copy display order to fulfilling order",
    "deleted_by": "Deleted by",
    "all_day": "All day",
    "delete_guest_title": "Delete Guest",
    "guest_delete_confirmation": "Are you sure you want to delete this guest? Once the changes are saved, the deletion cannot be undone.",
    "guest_deleted": "Guest deleted",
    "guest_delete_error": "Deletion failed",
    "guest_delete_not_allowed": "Cannot delete guest with future reservations",
    "reservation_history": "Reservation history",
    "edit_merged_guest_data": "Edit merged guest data",
    "added_guest_data": "Added duest data",
    "final_data": "Final data",
    "merge_guests": "Merge guests",
    "merge_guests_confirmation": "Merge guests confirmation",
    "new_guest_profile_data": "New guest profile data",
    "merge_guests_alert": "When merging guests, the two existing guest profiles will be combined into a single profile. The new profile will include the reservation data from both previous profiles.",
    "process_can_not_be_reverted": "This process cannot be reverted.",
    "merge_successful": "Merge successful",
    "todays_deletes": "Today's deletions",
    "possible_duplications": "Possible duplications",
    "merge": "Merge",
    "seat_count": "Seat count",
    "table_selection": "Table selection",
    "apply": "Apply",
    "map": "Map",
    "select_from_list": "Select from list",
    "all_reservations": "Összes foglalás",
    "weekday": "Weekday",
    "active": "Active",
    "inactivate": "Inactivate",
    "inactive": "Inactive",
    "upload_file": "Upload file",
    "uploaded_attachments": "Uploaded attachments",
    "no_attachments_uploaded": "No attachments uploaded",
    "handle_incomplete_data": "Handle incomplete data",
    "guests_without_names_count": "{{count}} guests without names",
    "guests_without_email_or_phone_number": "{{count}} guests without email or phone number",
    "auto_arrange_tables": "Auto arrange tables",
    "back": "Back",
    "reservation_type": "Reservation type",
    "country": "Country",
    "voucher_total_value": "Gift voucher monthly value",
    "total_value": "Total value",
    "create": "Create",
    "previous_visits": "Previous visits",
    "no_consumption_data": "No consumption data available for this guest.",
    "load_more": "Load more",
    "show_more": "Show more",
    "show_less": "Show less",
    "tip": "Tip",
    "stats": {
        "daily_refresh_notice": "Statistical data is refreshed once a day, overnight, so changes to reservation data and the guest database will only be visible on this page later.",
        "ntak_time_frames": {
            "last_week": "Last week",
            "last_month": "Last month",
            "ninety_days": "Last 90 days",
            "last_6_months": "Last 6 months"
        },
        "returning_guest_note": "The chart includes guests whose first visit to the restaurant was after {{fromDate}}.",
        "total_spent": "Total spent",
        "total_tips": "Total tips",
        "average_order_value": "Average order value",
        "tip_ratio": "Tip ratio",
        "avg_spending_per_guest": "Avg spending / guest",
        "payment_methods": {
            "KESZPENZHUF": "Cash (HUF)",
            "KESZPENZEUR": "Cash (EUR)",
            "SZEPKARTYA": "SZÉP card",
            "BANKKARTYA": "Bank card",
            "ATUTALAS": "Transfer",
            "EGYEB": "Other",
            "VOUCHER": "Gift voucher",
            "SZOBAHITEL": "Room credit",
            "KEREKITES": "Rounding"
        },
        "top_items_by_event_type": "Top items by event type",
        "items_by_popularity": "Items by popularity",
        "sort_by_quantity": "By order count",
        "sort_by_spend": "By spend",
        "quantity": "Quantity",
        "total_huf": "Total (Ft)",
        "reservation_count": "Reservation count",
        "avg_reservation_per_guest": "Avg spending / guest",
        "most_spending_guests": "Top spending guests",
        "avg_spending_per_reservation": "Avg spending / reservation"
    },
    "modified": "Modified ",
    "value": "Value",
    "giftcard_purchase_data": "Gift card purchase details",
    "resend_email": "Resend email",
    "purchased_vouchers": "Purchased vouchers",
    "save_buyer_data": "Save buyer data",
    "save_buyer_data_confirmation": "The changes will apply to all vouchers in this transaction, and the gift cards will be searchable by the updated details. Are you sure you want to continue?",
    "resend_email_confirmation": "Are you sure you want to resend the gift cards to the buyer's email address?",
    "save_failed": "Save failed",
    "resend_success": "Resend successful",
    "resend_failed": "Resend failed",
    "min_voucher_value": "Min. value",
    "max_voucher_value": "Max. value",
    "voucher_value_range_error": "Value must be between {{min}} and {{max}}",
    "voucher_sending_info": "The voucher will be sent to the provided email address",
    "send_voucher": "Send voucher",
    "voucher_sent_successfully": "Voucher sent successfully!",
    "internal_voucher_sending": "Internal voucher sending",
    "internal_voucher": "Internal voucher",
    "send_internal_voucher": "Send internal voucher",
    "display_text": "Display text",
    "value_voucher": "Value voucher",
    "value_vouchers": "Value vouchers",
    "chosen_voucher": "Chosen voucher",
    "experience_vouchers": "Experience vouchers",
    "created_at": "Created at",
    "current": "Current",
    "overwritten": "Overwritten"
};

export default commonEn;